import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { financialAccountKeys } from '../data-access/repositories/FinancialAccountRepository/queryKey.factory'

export const financialAccountQueryConfig = {
  getBalanceSummary: (scaToken?: string) => ({
    // scaToken may be undefined and must remain part of the key, so keep the
    // plain array literal — buildQueryKey would truncate at the first undefined.
    queryKey: [...financialAccountKeys.getBalanceSummary, scaToken],
  }),
  getScaAuthCode: () => ({
    queryKey: buildQueryKey([...financialAccountKeys.getScaAuthCode]),
  }),
  getScaToken: () => ({
    queryKey: buildQueryKey([...financialAccountKeys.getScaToken]),
  }),
  getAirwallexAuthCode: () => ({
    queryKey: buildQueryKey([...financialAccountKeys.getAirwallexAuthCode]),
  }),
}
